import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const queAnsByMe = async (reqBody) => {
  const token = await getFromEncLocalStorage("token");

  const data = await invokeApi(endPoints.questionsAnsweredbyMeApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: reqBody,
  });
  return data;
};

const QAnsweredbyMeService = { queAnsByMe };
export default QAnsweredbyMeService;
